import ApolloClient from 'apollo-boost';
import config from '../config/config.json';

let client;

export function init(bearer) {
  client = new ApolloClient({
    uri: `${config.api.url}/graphql`,
    headers: {
      authorization: bearer ? `Bearer ${bearer}` : ''
    }
  });

  return client;
}

export function getClient() {
  return client;
}

export default client;



// WEBPACK FOOTER //
// ./src/graphql/client.js